export { assert };
export { assertUsage };
export { assertWarning };
export { assertInfo };
export { getProjectError };
import { createErrorWithCleanStackTrace } from './createErrorWithCleanStackTrace';
import { projectInfo } from './projectInfo';
const errorPrefix = `[${projectInfo.npmPackageName}@${projectInfo.projectVersion}]`;
const internalErrorPrefix = `${errorPrefix}[Bug]`;
const usageErrorPrefix = `${errorPrefix}[Wrong Usage]`;
const warningPrefix = `${errorPrefix}[Warning]`;
const infoPrefix = `${errorPrefix}[Info]`;
const numberOfStackTraceLinesToRemove = 2;
function assert(condition, debugInfo) {
    if (condition) {
        return;
    }
    const debugStr = (() => {
        if (!debugInfo) {
            return '';
        }
        const debugInfoSerialized = typeof debugInfo === 'string' ? debugInfo : '`' + JSON.stringify(debugInfo) + '`';
        return `Debug info (this is for the ${projectInfo.projectName} maintainers; you can ignore this): ${debugInfoSerialized}.`;
    })();
    const internalError = createErrorWithCleanStackTrace([
        `${internalErrorPrefix} You stumbled upon a bug in ${projectInfo.projectName}'s source code.`,
        `Reach out at ${projectInfo.githubRepository}/issues/new and include this error stack (the error stack is usually enough to fix the problem).`,
        'A maintainer will fix the bug (usually under 24 hours).',
        `Do not hesitate to reach out as it makes ${projectInfo.projectName} more robust.`,
        debugStr
    ].join(' '), numberOfStackTraceLinesToRemove);
    throw internalError;
}
function assertUsage(condition, errorMessage) {
    if (condition) {
        return;
    }
    const whiteSpace = errorMessage.startsWith('[') ? '' : ' ';
    const usageError = createErrorWithCleanStackTrace(`${usageErrorPrefix}${whiteSpace}${errorMessage}`, numberOfStackTraceLinesToRemove);
    throw usageError;
}
function getProjectError(errorMessage) {
    const pluginError = createErrorWithCleanStackTrace(`${errorPrefix} ${errorMessage}`, numberOfStackTraceLinesToRemove);
    return pluginError;
}
let alreadyLogged = new Set();
function assertWarning(condition, errorMessage, { onlyOnce, showStackTrace }) {
    if (condition) {
        return;
    }
    const msg = `${warningPrefix} ${errorMessage}`;
    if (onlyOnce) {
        const key = onlyOnce === true ? msg : onlyOnce;
        if (alreadyLogged.has(key)) {
            return;
        }
        else {
            alreadyLogged.add(key);
        }
    }
    if (showStackTrace) {
        console.warn(new Error(msg));
    }
    else {
        console.warn(msg);
    }
}
function assertInfo(condition, errorMessage, { onlyOnce }) {
    if (condition) {
        return;
    }
    const msg = `${infoPrefix} ${errorMessage}`;
    if (onlyOnce) {
        const key = msg;
        if (alreadyLogged.has(key)) {
            return;
        }
        else {
            alreadyLogged.add(key);
        }
    }
    console.log(msg);
}
